module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="partialPaymentTooltip js-partial-payment-tooltip">\n	<div class="partialPaymentTooltip__container">\n		<a href="" class="icon-i16_x"></a>\n\n		<div class="partialPaymentTooltip__logo"></div>\n		<div class="partialPaymentTooltip__text">\n			Доступна <span class="js-tooltip-percent"></span>\n            <br> предоплата. Внесите<br><span class="js-tooltip-price"></span> и тур ваш!\n		</div>\n	</div>\n</div>\n';
}
return __p;
};
